
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.133 13.254L6.36 18.027c-.318.318-.742.318-1.06 0l-1.061-1.06c-.319-.319-.319-.743 0-1.061l4.773-4.773L4.239 6.36c-.319-.318-.319-.742 0-1.06l1.06-1.061c.319-.319.743-.319 1.061 0l4.773 4.773 4.773-4.773c.318-.319.742-.319 1.06 0l1.061 1.06c.318.319.318.743 0 1.061l-4.773 4.773 4.773 4.773c.318.318.318.742 0 1.06l-1.06 1.061c-.319.318-.743.318-1.061 0l-4.773-4.773z","fill":"#F1E41E","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_close_menu.svg